import React, { Component } from 'react'
import Avatar from '@material-ui/core/Avatar'
import Chip from '@material-ui/core/Chip'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'

import Link from '../Link/Link'

import CalendarIcon from '@material-ui/icons/DateRange'
import iconFacebook from '../../assets/images/sprites/32x32/icon-fb-32.png'
import iconTwitter from '../../assets/images/sprites/32x32/icon-twitter-32.png'

import stylesGlobal from '../../styles.js'

import './News.css'

var styles = {
  ...stylesGlobal,
  newsItem: {
    textAlign: 'left'
  }
}

class News extends Component {
  state = {
    type: null,
    title: null,
    image: {
      uri: null
    },
    excerpt: null,
    body: null
  }

  componentDidMount() {
    this.setState({
      ...this.props.post
    })
  }

  render() {
    const url = `${window.location.origin}/posts/${encodeURIComponent(this.state.slug)}`

    return (
      <div class="foo" style={this.state.type === 'event' ? { ...styles.featuredColumn, ...styles.newsItem } : styles.newsItem}>
        <Link href={url}>
          <Typography variant="subheading" paragraph={true} component="span" color="inherit">{this.state.title}</Typography>
        </Link>

        {this.state.image.uri ? <Link href={url}>
          <img src={this.state.image.uri} alt={this.state.title} style={{
            maxHeight: '200px',
            maxWidth: '100%'
          }} />
        </Link> : null}

        <Typography variant="body1" paragraph={true} color="inherit">{this.state.excerpt || (this.state.body || '').substr(0, 500)}</Typography>

        <div>
          <Link href={`www.facebook.com/sharer/sharer.php?u=${url}`}>
            <img src={iconFacebook} alt="facebook" />
          </Link>
          &nbsp;
           <Link href={`www.twitter.com/share?url=${url}`}>
            <img src={iconTwitter} alt="twitter" />
          </Link>
        </div>

        <Grid container direction="row" justify="space-between" alignItems="center">
          <Link href={url}>Read more</Link>
          {
            this.state.type === 'event' ?
              <Chip avatar={<Avatar><CalendarIcon /></Avatar>} label={this.state.type} color="primary"></Chip>
              : null
          }
        </Grid>
      </div>
    )
  }
}

export default News


// WEBPACK FOOTER //
// ./src/components/News/News.js